module.exports = __webpack_public_path__ + "static/media/desktopScreenshot02.96e0a459.jpg";